import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

// Captura o código de indicação de cliente (/r/CODE), guarda-o e envia para o registo.
export default function ReferralRedirect() {
    const { code } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        const clean = (code || "").toUpperCase();
        if (clean) {
            try { window.localStorage.setItem("caseirinho_ref", clean); } catch { /* ignore */ }
        }
        navigate(`/register?ref=${encodeURIComponent(clean)}`, { replace: true });
    }, [code, navigate]);
    return null;
}
